import React from "react";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";

interface LoaderProps {
  label: string;
}

const Loader: React.FC<LoaderProps> = ({ label }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <Spinner label={label} size={SpinnerSize.large} />
  </div>
);

export default Loader;
